import Vue from 'vue';
import { polygon } from '@turf/helpers';
import centerOfMass from '@turf/center-of-mass';
import distance from '@turf/distance';
import FavoriteButton from '../components/FavoriteButton.vue';
import AppMap from '../components/AppMap.vue';
import LazyList from '../components/LazyList.vue';
import vSelect from 'vue-select';
import VueRouter from 'vue-router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import FairgroundPreview from '../components/FairgroundPreview.vue';
Vue.use(VueAxios, axios);

const router = new VueRouter({ mode: 'history', routes: [{ path: '*', name: 'map' }] });
Vue.use(VueRouter);
Vue.component('FavoriteButton', FavoriteButton);
Vue.component('AppMap', AppMap);
Vue.component('LazyList', LazyList);
Vue.component('FairgroundPreview', FairgroundPreview);
vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: (createElement) => createElement('div', ''),
  },
});
Vue.component('VSelect', vSelect);
Vue.filter('distance', (value) => {
  if (!value) return '';
  if (value < 0.5) {
    return Math.round(value * 1000) + ' m';
  }
  return Math.round(value * 10) / 10 + ' km';
});
const offers = window.offers;
const tops = window.tops;
const hideOffers = window.hideAllOffers;
const types = window.types;
const targetGroups = window.targetGroups;
// const MAX_MOST_POPULAR_OFFERS = 15;

export default async function initMap() {
  const map = document.querySelector('.map');
  if (!map) {
    return;
  }
  /* eslint-disable no-new */
  new Vue({
    router,
    el: document.querySelector('.map'),
    data() {
      return {
        sorting: 'alphabet',
        allOffers: [],
        tops: {},
        search: '',
        top: [],
        type: [],
        targetGroup: [],
        fairgrounds: [],
        showPopup: false,
        selectedItem: null,
        userPosition: null,
        isMapOpen: false,
        mostPopular: false,
        myFavorite: false,
        myfavorites: {},
        showOfferItems: false, // used to delay the initial blocking rendering
        isDisabledLocation: null,
      };
    },
    computed: {
      allTypes() {
        return types;
      },
      targetGroups() {
        return targetGroups;
      },
      allFairgrounds() {
        const fairgrounds = {};
        this.rawFairgroundsGeoJson.forEach((fairground) => {
          fairgrounds[fairground.id] = {
            id: fairground.id,
            slug: fairground.properties.id,
            title: fairground.properties.title,
          };
        });
        return fairgrounds;
      },
      fairgroundSlugs() {
        return this.rawFairgroundsGeoJson.map((fairground) => fairground.properties.id);
      },
      hideOffers() {
        return hideOffers;
      },
      amountOffers() {
        return this.allOffers.length;
      },
      resultOffers() {
        return this.offers.length;
      },
      filtersLength() {
        return (
          this.top.length +
          this.type.length +
          this.targetGroup.length +
          this.fairgrounds.length +
          (this.myFavorite ? 1 : 0)
        );
      },
      offersGeoJson() {
        return this.sortedOffers
          .filter((offer) => offer.coordinates && offer.coordinates.length)
          .map((offer) => {
            return {
              type: 'Feature',
              properties: {
                id: offer.id,
                title: offer.title,
                color: offer.color,
                center: offer.center,
                distance: offer.distance,
              },
              geometry: { type: 'MultiPolygon', coordinates: offer.coordinates },
            };
          });
      },
      fairgroundsGeoJson() {
        return this.rawFairgroundsGeoJson.map((fairground) => {
          const center = this.centerCoordinates(fairground.geometry.coordinates[0]);
          const userDistance = this.userPosition && distance(this.userPosition, center);
          return {
            type: 'Feature',
            geometry: { type: 'MultiPolygon', coordinates: fairground.geometry.coordinates },
            properties: Object.assign({}, fairground.properties, {
              center: center.geometry.coordinates,
              distance: userDistance,
              id: fairground.properties.id,
              title: fairground.properties.title,
              url: fairground.properties.url,
              image: fairground.properties.image,
              teaserDescription: fairground.properties.teaserDescription,
            }),
          };
        });
      },
      offers() {
        if (this.search.length > 2) {
          const serachWord = this.search.toLowerCase();
          return this.sortedOffers.filter((offer) => {
            const searchKeywords = `${offer.title} ${offer.description} ${offer.searchKeywords} ${
              this.allFairgrounds[offer.fairgroundId]?.title
            }`;
            return searchKeywords.toLowerCase().includes(serachWord);
          });
        }

        let offers = this.sortedOffers.filter((offer) => {
          if (this.top.length && !this.contains(offer.top, this.top)) {
            return false;
          }

          if (this.type.length && !this.contains(offer.type, this.type)) {
            return false;
          }

          if (this.targetGroup.length && !this.contains(offer.targetGroup, this.targetGroup)) {
            return false;
          }

          if (
            this.fairgrounds.length &&
            this.allFairgrounds[offer.fairgroundId] &&
            this.fairgrounds.indexOf(this.allFairgrounds[offer.fairgroundId].slug) === -1
          ) {
            return false;
          }

          return true;
        });

        // if (this.mostPopular) {
        //   offers = offers
        //     .filter((offer) => offer.favorites)
        //     .sort((a, b) => (a.favorites > b.favorites ? -1 : 1))
        //     .slice(0, MAX_MOST_POPULAR_OFFERS);
        //   offers = this.sortOffers(offers);
        // }

        if (this.myFavorite) {
          offers = offers.filter((offer) => this.myfavorites[offer.id]);
        }

        return offers;
      },
      sortedOffers() {
        const sortedOffers = this.allOffers.map((offer) => {
          const center = offer.coordinates && this.centerCoordinates(offer.coordinates[0]);
          const userDistance = center && this.userPosition && distance(this.userPosition, center);

          return Object.assign({}, offer, {
            center: center && center.geometry.coordinates,
            distance: userDistance,
          });
        });

        return this.sortOffers(sortedOffers);
      },
      rawFairgroundsGeoJson() {
        return window.fairgroundsGeoJson || [];
      },
      fairground() {
        if (!this.selectedItem || this.selectedItem.type !== 'fairgrounds') {
          return null;
        }

        const fairground = this.fairgroundsGeoJson.find(
          (fairground) => fairground.properties.id === this.selectedItem.id,
        );

        return {
          id: fairground.properties.id,
          title: fairground.properties.title,
          url: fairground.properties.url,
          image: fairground.properties.image,
          teaserDescription: fairground.properties.teaserDescription,
          center: fairground.properties.center,
        };
      },
      preview() {
        if (!this.selectedItem || this.selectedItem.type !== 'offers') {
          return null;
        }

        const offer = this.sortedOffers.find((offer) => offer.id === this.selectedItem.id);
        const offerGeoJson = this.offersGeoJson.find((offer) => offer.properties.id === this.selectedItem.id);

        return {
          id: offer.id,
          title: offer.title,
          url: offer.url,
          image: offer.image,
          center: (offerGeoJson && offerGeoJson.properties.center) || this.userPosition,
          distance: offer.distance,
          fairgroundTitle: this.allFairgrounds[offer.fairgroundId].title,
          typeIcon: this.allTypes[offer.type].icon,
          top: offer.top,
        };
      },
    },
    watch: {
      '$route.query.myFavorite'(myFavorite) {
        if ((this.myFavorite && !myFavorite) || (!this.myFavorite && myFavorite)) {
          this.myFavorite = !!myFavorite;
        }
      },
      '$route.query.top'(top) {
        if (this.top.join() !== top) {
          this.top = top?.split(',') || [];
        }
      },
      '$route.query.type'(type) {
        if (this.type.join() !== type) {
          this.type = type?.split(',') || [];
        }
      },
      '$route.query.group'(group) {
        if (this.targetGroup.join() !== group) {
          this.targetGroup = group?.split(',') || [];
        }
      },
      '$route.query.fairground'(fairgrounds) {
        if (this.fairgrounds.join() !== fairgrounds) {
          this.fairgrounds = fairgrounds?.split(',') || [];
        }
      },
      top() {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        delete query.offer;
        if (this.top.length) {
          query.top = this.top.join();
        } else {
          delete query.top;
        }
        if (this.$route.query.top !== query.top) {
          this.$router.push({ path: this.$route.path, query });
        }
      },
      type() {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        delete query.offer;
        if (this.type.length) {
          query.type = this.type.join();
        } else {
          delete query.type;
        }
        if (this.$route.query.type !== query.type) {
          this.$router.push({ path: this.$route.path, query });
        }
      },
      targetGroup() {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        delete query.offer;
        if (this.targetGroup.length) {
          query.group = this.targetGroup.join();
        } else {
          delete query.group;
        }
        if (this.$route.query.group !== query.group) {
          this.$router.push({ path: this.$route.path, query });
        }
      },
      myFavorite() {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        delete query.offer;
        if (this.myFavorite) {
          query.myFavorite = 1;
        } else {
          delete query.myFavorite;
        }
        if (this.$route.query.myFavorite !== query.myFavorite) {
          this.$router.push({ path: this.$route.path, query });
        }
      },
      selectedItem(newItem) {
        if (!newItem || newItem.type !== 'offers') {
          return;
        }

        this.scrollOfferIntoView(newItem.id);
      },
      isMapOpen(newState) {
        const body = document.querySelector('body');
        if (newState) {
          body.classList.add('map-active');
        } else {
          body.classList.remove('map-active');
        }
      },
      async sorting(newMode) {
        if (newMode !== 'by_distance') {
          return;
        }

        if (this.isDisabledLocation === true) {
          this.sorting = 'alphabet';
          return;
        }

        if (this.isDisabledLocation === false) {
          return;
        }

        try {
          await this.getGeoLocation();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.info(error.message);
        }
      },
      fairgrounds() {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        delete query.offer;
        if (this.fairgrounds.length) {
          query.fairground = this.fairgrounds.join();
        } else {
          delete query.fairground;
        }
        if (this.$route.query.fairground !== query.fairground) {
          this.$router.push({ path: this.$route.path, query });
        }

        if (this.fairgrounds.length === 1 && this.selectedItem?.id === this.fairgrounds[0]) {
          return;
        }
        if (this.fairgrounds.length === 1) {
          this.selectFairground(this.fairgrounds[0]);
          return;
        }
        if (this.selectedItem && this.fairgrounds.length && this.selectedItem.id !== this.fairgrounds[0]) {
          this.selectedItem = null;
        }
      },
    },
    async mounted() {
      this.allOffers = offers;
      this.tops = tops;

      // console.log('mounted', this.$route.query);

      if (this.$route.query.top) {
        this.top = this.$route.query.top.split(',').filter((top) => this.tops[top]);
      }

      if (this.$route.query.type) {
        this.type = this.$route.query.type.split(',').filter((type) => this.allTypes[type]);
      }

      if (this.$route.query.group) {
        this.targetGroup = this.$route.query.group.split(',').filter((group) => this.targetGroups[group]);
      }

      if (this.$route.query.myFavorite) {
        this.myFavorite = true;
      }

      // show map on mobile
      if (this.$route.query.view && this.$route.query.view === 'map') {
        this.isMapOpen = true;
      }

      try {
        const localFavorites = localStorage.getItem('favorites') || '{}';
        this.myfavorites = JSON.parse(localFavorites);
      } catch (error) {}

      window.addEventListener('favorites', this.listenFavoritesEvent, false);

      const response = await this.axios.get('/api/favorites');
      const favorites = {};
      response.data.forEach((favorite) => {
        favorites[favorite.offer_id] = parseInt(favorite.count);
      });

      this.allOffers.forEach((offer) => (offer.favorites = favorites[offer.id] || 0));

      try {
        const rawFilters = this.$route.query.filters;
        if (rawFilters) {
          const filters = rawFilters.split(';');
          filters.forEach((filter) => {
            const [filterName, filterValue] = filter.split(':');
            if (!['top', 'type', 'targetGroup', 'fairgrounds'].includes(filterName)) {
              return;
            }

            this[filterName] = [filterValue];
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.info(error.message);
      }

      // Delay showing offer list until the main component is rendered to avoid blocking
      this.$nextTick(() => {
        this.showOfferItems = true;
      });
    },
    beforeDestroy() {
      window.removeEventListener('favorites', this.listenFavoritesEvent, false);
    },
    methods: {
      mapLoaded() {
        if (this.$route.query.fairground) {
          this.fairgrounds = this.$route.query.fairground
            .split(',')
            .filter((fairground) => this.fairgroundSlugs.includes(fairground));
        }
        setTimeout(() => {
          if (this.$route.query.offer) {
            this.selectOffer(this.$route.query.offer);
          }
        }, 66);
      },
      async getGeoLocation() {
        let result;
        try {
          result = await navigator.permissions.query({ name: 'geolocation' });
        } catch (e) {
          result = await new Promise((resolve, reject) =>
            navigator.geolocation.getCurrentPosition(resolve, () => {
              this.isDisabledLocation = true;
              this.sorting = 'alphabet';
            }),
          );
        }

        // eslint-disable-next-line no-undef
        if (result instanceof GeolocationPosition || result.state === 'prompt') {
          navigator.geolocation.getCurrentPosition(this.grantUserPosition, () => {
            this.isDisabledLocation = true;
            this.sorting = 'alphabet';
          });
        } else if (result.state === 'granted') {
          navigator.geolocation.getCurrentPosition(this.grantUserPosition);
        } else {
          this.isDisabledLocation = true;
          this.sorting = 'alphabet';
        }
      },
      listenFavoritesEvent(event) {
        this.myfavorites[event.detail.offerId] = event.detail.state;
      },
      openFilterPopup() {
        this.showPopup = true;
        this.$nextTick(() => {
          this.$refs.filterPopup.querySelector('.popup__main').focus();
        });
      },
      sortOffers(sortedOffers) {
        if (this.sorting === 'alphabet' || (this.sorting === 'by_distance' && !this.userPosition)) {
          return sortedOffers.slice(0).sort((a, b) => a.title.localeCompare(b.title));
        }

        if (this.sorting === 'popularity') {
          return sortedOffers.slice(0).sort((a, b) => (a.favorites > b.favorites ? -1 : 1));
        }

        if (this.sorting === 'by_distance') {
          return sortedOffers.slice(0).sort((a, b) => {
            if (a.distance === b.distance) {
              return 0;
            }
            if (!a.distance) {
              return 1;
            }
            if (!b.distance) {
              return -1;
            }
            return a.distance < b.distance ? -1 : 1;
          });
        }
      },
      openMap() {
        this.isMapOpen = true;
      },
      centerCoordinates(polygonCoordinates) {
        try {
          const shape = polygon(polygonCoordinates);
          const center = centerOfMass(shape);
          return center;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Could not find center', error);
          // eslint-disable-next-line no-console
          console.info(polygonCoordinates);
        }
      },
      contains(array, searchInArray) {
        if (!array) {
          return false;
        }
        return searchInArray.some((value) => array.indexOf(value) !== -1);
      },
      closePopup() {
        this.showPopup = false;
      },
      clear() {
        this.top = [];
        this.type = [];
        this.targetGroup = [];
        this.fairgrounds = [];
        this.mostPopular = false;
        this.myFavorite = false;
        this.search = '';
        if (this.selectedItem && this.selectedItem.type === 'fairgrounds') {
          this.selectedItem = null;
        }
      },
      clearSearch() {
        this.search = '';
      },
      filter() {
        this.showPopup = true;
      },
      selectFairground(id) {
        const query = JSON.parse(JSON.stringify(this.$route.query));

        if (this.selectedItem && this.selectedItem.id === id) {
          this.selectedItem = null;
          this.fairgrounds = [];
          delete query.fairground;
          this.$router.push({ path: this.$route.path, query });
          return;
        }
        this.selectedItem = {
          type: 'fairgrounds',
          id: id,
        };

        this.fairgrounds = [id];

        if (id !== this.$route.query.fairground) {
          query.fairground = id;
          this.$router.push({ path: this.$route.path, query });
        }
      },
      goToOffer(id) {
        this.$refs.map.selectItem({
          type: 'offers',
          id: id,
        });
      },
      selectOffer(id, redirect = false) {
        const query = JSON.parse(JSON.stringify(this.$route.query));

        const offer = this.offers.find((offer) => offer.id === id);
        if (redirect && window.innerWidth < 960) {
          if (!offer) return (window.location.href = this.fairground.url);
          return (window.location.href = offer.url);
        }
        if (!offer && this.allFairgrounds[id]) this.selectFairground(id);
        if (this.selectedItem && this.selectedItem.id === id) {
          this.selectedItem = null;
          delete query.offer;
          this.$router.push({ path: this.$route.path, query });
          return;
        }

        this.selectedItem = {
          type: 'offers',
          id: id,
        };
        if (id !== this.$route.query.offer) {
          query.offer = id;
          this.$router.push({ path: this.$route.path, query });
        }
      },
      setUserPosition(position) {
        this.userPosition = position;
      },
      grantUserPosition(position) {
        this.isDisabledLocation = false;
        this.setUserPosition([position.coords.longitude, position.coords.latitude]);
      },
      scrollOfferIntoView(offerId) {
        const element = this.$refs[`offer_${offerId}`];
        if (!element || element.length === 0 || !element[0]?.scrollIntoView) {
          return;
        }

        element[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      },
    },
  });
}
